
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSideProps } from 'next';
import useLocale from 'next-translate/useTranslation';
import React from 'react';
import { useRouter } from 'next/router';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
const TermsOfUse = () => {
    // Opened from inside the iOS app (?from=app): drop the marketing nav
    // and footer, both of which link to /pricing — a purchase call to
    // action App Store guideline 3.1.3(b) does not allow in-app.
    const router = useRouter();
    const isFromApp = router.query.from === 'app';
    const { t } = useLocale('terms-of-use');
    return (<main>
      <Seo templateTitle={t('Terms and Conditions')} image={`https://easy-peasy.ai/api/og-template?title=${t('Terms and Conditions')}`}/>
      <div className='relative bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative z-10 bg-white dark:bg-slate-900 sm:pb-8'>
            {!isFromApp && <LandingPageNavigation />}
          </div>
        </div>
      </div>
      <section className='bg-white px-4 py-16 dark:bg-slate-900 sm:px-6 lg:px-8'>
        <div className='prose prose-lg prose-indigo mx-auto mt-6 text-gray-500 dark:text-slate-400'>
          <h1 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Terms & Conditions')}
          </h1>

          <p>{t('operated_by')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('General Terms')}
          </h2>
          <p>{t('general_terms_1')}</p>
          <p>{t('general_terms_2')}</p>
          <p>{t('general_terms_3')}</p>
          <p>{t('general_terms_4')}</p>
          <p>{t('general_terms_5')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('License')}
          </h2>
          <p>{t('license_1')}</p>
          <p>{t('license_2')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Use Rights and Restrictions')}
          </h2>
          <p>{t('use_rights_intro')}</p>
          <ul>
            <li>
              <strong>{t('Free Users:')}</strong> {t('free_users_text')}
            </li>
            <li>
              <strong>{t('Paid Users:')}</strong> {t('paid_users_text')}
            </li>
          </ul>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Fair Usage and Token Limits')}
          </h2>
          <p>{t('fair_usage_1')}</p>
          <p>{t('fair_usage_2')}</p>
          <p>{t('fair_usage_3')}</p>
          <p>{t('fair_usage_4')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Definitions and key terms')}
          </h2>
          <p>{t('definitions_intro')}</p>
          <ul>
            <li>{t('def_cookie')}</li>
            <li>{t('def_company')}</li>
            <li>{t('def_country')}</li>
            <li>{t('def_device')}</li>
            <li>{t('def_third_party')}</li>
            <li>{t('def_website')}</li>
          </ul>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Restrictions')}
          </h2>
          <p>{t('restrictions_intro')}</p>
          <ul>
            <li>{t('restriction_1')}</li>
            <li>{t('restriction_2')}</li>
            <li>{t('restriction_3')}</li>
            <li>{t('restriction_4')}</li>
            <li>{t('restriction_5')}</li>
          </ul>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Links to Other Websites')}
          </h2>
          <p>{t('links_1')}</p>
          <p>{t('links_2')}</p>
          <p>{t('links_3')}</p>
          <p>{t('links_4')}</p>
          <p>{t('links_5')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Cookies')}
          </h2>
          <p>{t('cookies_1')}</p>
          <p>{t('cookies_2')}</p>
          <p>{t('cookies_3')}</p>
          <p>{t('cookies_4')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Changes to the Provision of the Website/Services')}
          </h2>
          <h3 className='font-bold'>{t('Changes to the Website/Services')}</h3>
          <p>{t('changes_website_1')}</p>
          <ul>
            <li>{t('changes_item_1')}</li>
            <li>{t('changes_item_2')}</li>
            <li>{t('changes_item_3')}</li>
            <li>{t('changes_item_4')}</li>
            <li>{t('changes_item_5')}</li>
            <li>{t('changes_item_6')}</li>
          </ul>
          <p>{t('changes_website_2')}</p>

          <h3 className='font-bold'>{t('Service Interruptions and Data Loss')}</h3>
          <p>{t('service_interruptions_1')}</p>
          <p>{t('service_interruptions_2')}</p>
          <ul>
            <li>{t('interruption_item_1')}</li>
            <li>{t('interruption_item_2')}</li>
            <li>{t('interruption_item_3')}</li>
            <li>{t('interruption_item_4')}</li>
            <li>{t('interruption_item_5')}</li>
            <li>{t('interruption_item_6')}</li>
            <li>{t('interruption_item_7')}</li>
          </ul>
          <p>{t('service_interruptions_3')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Third-Party Services')}
          </h2>
          <p>{t('third_party_1')}</p>
          <p>{t('third_party_2')}</p>
          <p>{t('third_party_3')}</p>
          <p>{t('third_party_4')}</p>
          <p>{t('third_party_5')}</p>
          <p>{t('third_party_6')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Term and Termination')}
          </h2>
          <p>{t('termination_1')}</p>
          <p>{t('termination_2')}</p>
          <p>{t('termination_3')}</p>
          <p>{t('termination_4')}</p>
          <p>{t('termination_5')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Copyright Infringement Notice')}
          </h2>
          <p>{t('copyright_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Indemnification')}
          </h2>
          <p>{t('indemnification_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('No Warranties')}
          </h2>
          <p>{t('no_warranties_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Limitation of Liability')}
          </h2>
          <p>{t('limitation_1')}</p>
          <p>{t('limitation_2')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Severability')}
          </h2>
          <p>{t('severability_1')}</p>
          <p>{t('severability_2')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Waiver')}
          </h2>
          <p>{t('waiver_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Changes to Terms and Conditions')}
          </h2>
          <p>{t('changes_terms_1')}</p>
          <p>{t('changes_terms_2')}</p>
          <p>{t('changes_terms_3')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Entire Agreement')}
          </h2>
          <p>{t('entire_agreement_1')}</p>
          <p>{t('entire_agreement_2')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Intellectual Property')}
          </h2>
          <p>{t('intellectual_property_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Governing Law')}
          </h2>
          <p>{t('governing_law_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Notice of Dispute')}
          </h2>
          <p>{t('notice_dispute_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Submissions and Privacy')}
          </h2>
          <p>{t('submissions_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Promotions')}
          </h2>
          <p>{t('promotions_1')}</p>
          <p>{t('promotions_2')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Typographical Errors')}
          </h2>
          <p>{t('typographical_1')}</p>
          <p>{t('typographical_2')}</p>
          <ul>
            <li>{t('typographical_item_1')}</li>
            <li>{t('typographical_item_2')}</li>
            <li>{t('typographical_item_3')}</li>
            <li>{t('typographical_item_4')}</li>
          </ul>
          <p>{t('typographical_3')}</p>
          <ul>
            <li>{t('typographical_refund_1')}</li>
            <li>{t('typographical_refund_2')}</li>
            <li>{t('typographical_refund_3')}</li>
            <li>{t('typographical_refund_4')}</li>
          </ul>
          <p>{t('typographical_4')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Miscellaneous')}
          </h2>
          <p>{t('miscellaneous_text')}</p>

          <h2 className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Contact Us')}
          </h2>
          <p>{t('contact_intro')}</p>
          <ul>
            <li>{t('contact_email')}</li>
            <li>{t('contact_link')}</li>
          </ul>
        </div>
      </section>
      {!isFromApp && <Footer />}
    </main>);
};
// Redirect non-English locales to English version
const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    if (locale && locale !== 'en') {
        return {
            redirect: {
                destination: '/terms-of-use',
                permanent: true,
            },
        };
    }
    return {
        props: {},
    };
};
export default TermsOfUse;

    async function __Next_Translate__getServerSideProps__1a0cbfb6533__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/terms-of-use',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0cbfb6533__ as getServerSideProps }
  